import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22inter.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./inter-latin-400-normal.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./inter-latin-500-normal.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./inter-latin-600-normal.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./inter-latin-700-normal.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./inter-latin-800-normal.woff2%22,%22weight%22:%22800%22,%22style%22:%22normal%22},{%22path%22:%22./inter-latin-900-normal.woff2%22,%22weight%22:%22900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22variable%22:%22--font-inter%22,%22fallback%22:[%22system-ui%22,%22arial%22]}],%22variableName%22:%22inter%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'inter', 'inter Fallback', system-ui, arial",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
